import type { ReactNode } from 'react'
import './card-columns.css'

/**
 * One record read as cards: two columns that stack independently, so a tall
 * card on one side never leaves a hole beside a short one on the other. Two
 * where the measure holds them, one where it does not — the leading column
 * first. A record whose second column has nothing to show takes the whole
 * measure for the first.
 *
 * Not a collection: a list of records keeps its cards full-width. This is the
 * facts of ONE record, grouped.
 */
export function CardColumns({
  start,
  end,
}: {
  start: ReactNode
  end?: ReactNode
}) {
  return (
    <div className="card-columns">
      <div className="card-columns__stack">{start}</div>
      {end ? <div className="card-columns__stack">{end}</div> : null}
    </div>
  )
}
